<template>
  <div>
    <div id="myNotice">
      <div class="topTitle">公告中心</div>
      <div class="myNotice">
        <!-- <div class="leftTitle">
          <div class="leftLine">
            <div v-if="type == 1" class="activeLine"></div>
            <div v-if="type == 2" class="activeLine position1"></div>
            <div v-if="type == 3" class="activeLine position2"></div>
            <div v-if="type == 4" class="activeLine position3"></div>
            <div v-if="type == 5" class="activeLine position4"></div>
          </div>
          <div class="leftContent">
            <p :class="type == 1 ? 'activeContent' : ''" @click="type = 1">通知公告</p>
            <p :class="type == 2 ? 'activeContent' : ''" @click="type = 2">中心动态</p>
            <p :class="type == 3 ? 'activeContent' : ''" @click="type = 3">行业动态</p>
            <p :class="type == 4 ? 'activeContent' : ''" @click="type = 4">供求信息</p>
            <p :class="type == 5 ? 'activeContent' : ''" @click="type = 5">行情简报</p>
          </div>
        </div> -->
        <div class="rightContent">
          <div class="dataWrap">
            <noticeList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import noticeList from '../notice/tab/NoticeList.vue'
export default {
  components: {
    noticeList
  },
  data() {
    return {
      type: 1
    }
  }
}
</script>
<style lang="scss" scoped>
#myNotice {
  background-color: #ffffff;
  min-height: calc(100vh - 50px);
  .topTitle {
    height: 100px;
    line-height: 100px;
    background-color: #262941;
    font-weight: 500;
    color: #ffffff;
    font-size: 30px;
    text-align: center;
  }
  .myNotice {
    display: flex;
    width: 85%;
    margin: 0 auto;
    justify-content: center;
    // padding-top: 40px;
    .leftTitle {
      display: flex;
      width: 200px;
      .leftLine {
        position: relative;
        width: 3px;
        height: 236px;
        background: #e6e6e6;
        border-radius: 2px;
        .activeLine {
          width: 3px;
          height: 18px;
          background: rgba(36, 131, 255, 0.8);
          border-radius: 2px;
          position: absolute;
          top: 15px;
        }
        .position1{
          top: 60px;
        }
        .position2{
          top: 108px;
        }
        .position3{
          top: 156px;
        }
        .position4{
          top: 204px;
        }
      }
      .leftContent {
        padding: 15px 0;
        p {
          cursor: pointer;
          padding-bottom: 24px;
          padding-left: 24px;
          color: #b4b4b4;
          font-weight: 600;
          font-size: 17px;
        }
        .activeContent {
          color: #2383ff;
        }
      }
      .leftContent > p:last-child {
        padding-bottom: 0;
      }
    }
    .rightContent {
      width: 90%;
      .dataWrap {
        // padding-left: 5%;s
        .title1 {
          font-weight: 600;
          color: rgba(255, 255, 255, 0.8);
          font-size: 29px;
        }
      }
    }
  }
}
</style>
